// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"870":"c665aafb","2255":"3b1e880a","4621":"c665aafb","5081":"c665aafb","7565":"c665aafb","9238":"3b1e880a"}[chunkId] + ".chunk.css";
};